module.exports = __webpack_public_path__ + "img/bio-1.c64f343.jpg";